var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6669 0C36.7671 0 28.0665 2.63919 20.6663 7.58384C13.2661 12.5285 7.49838 19.5565 4.09244 27.7792C0.686508 36.0017 -0.204661 45.05 1.53166 53.7789C3.26799 62.5083 7.55384 70.5262 13.8472 76.82C20.1406 83.1132 28.1588 87.3989 36.888 89.1354C45.6169 90.8718 54.6652 89.9802 62.8879 86.5743C71.1105 83.1684 78.1384 77.401 83.0833 70.0008C88.0277 62.6006 90.6669 53.9004 90.6669 45C90.6669 33.0652 85.9256 21.6193 77.487 13.1802C69.0478 4.74103 57.6015 0 45.6669 0ZM67.7732 30.825L60.4044 65.6437C59.8419 68.1187 58.3794 68.6812 56.2982 67.5562L45.0482 59.2312L39.4232 64.4624C39.1583 64.8084 38.818 65.0896 38.4281 65.2848C38.0383 65.4794 37.6091 65.5829 37.1732 65.5874L37.9607 54.3374L58.7732 35.4937C59.7294 34.7062 58.7732 34.2562 57.4232 35.0437L31.8857 51.075L20.6357 47.5875C18.217 46.8562 18.1607 45.1687 21.142 44.0437L64.5107 27.1687C66.6482 26.55 68.4482 27.7875 67.7732 30.825Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinTelegram);
export default __webpack_public_path__ + "static/media/JoinTelegram.eda472debb8f6f181746765625f8d6f7.svg";
export { ForwardRef as ReactComponent };